import { render, staticRenderFns } from "./SettingsComponent.vue?vue&type=template&id=55bcfa6f&"
import script from "./SettingsComponent.vue?vue&type=script&lang=js&"
export * from "./SettingsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports